import type { ReactNode } from 'react';
import { customRichTextTags as sharedRichTextTags } from '@/utils/i18n';

// 메인 시안은 1200px 미만에서 모바일 배치와 줄바꿈을 함께 유지한다.
export const customRichTextTags = {
  ...sharedRichTextTags,
  br: () => <br className="hidden xl:block" />,
  mobileBr: () => <br className="block xl:hidden" />,
  desktopText: (chunk: ReactNode) => (
    <span className="hidden xl:inline">{chunk}</span>
  ),
  mobileText: (chunk: ReactNode) => (
    <span className="inline xl:hidden">{chunk}</span>
  ),
};

// 시안이 모바일·데스크톱에서 같은 위치를 끊는 제목용. `<br>` 의 데스크톱 전용 분기를
// 일부러 쓰지 않는다는 뜻이라, 호출부마다 인라인으로 덮어쓰지 말고 이 상수를 쓴다.
export const alwaysBreakRichTextTags = {
  ...customRichTextTags,
  br: () => <br />,
};
